export default function(urlString) {
  const url = new URL(urlString || window.location);
  const hash = url.hash.substr(1);

  return hash.split('&').reduce(function (result, item) {
    const parts = item.split('=');
    result[parts[0]] = parts[1];
    return result;
  }, {});
}